import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import AppStoreIcon from "../../../../assets/svgs/app-store-dark.svg";
import GooglePlayIcon from "../../../../assets/svgs/google-play-dark.svg";
import SubMenuItem from "../SubMenuItem";
import Link from "../../../Link";

const TradeMenu = ({ isActive, siteCountry }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      ...TradeMenuIcons
    }
  `);

  return (
    <div
      id="sub-menu__trade"
      className={cx(
        "container pl-xl-4 sub-menu sub-menu__trade row",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="d-flex flex-column col mx-1 mx-xl-3 mt-5">
        <span
          className={cx("row title", {
            "order-2 mt-3 pl-3": siteCountry === "id",
          })}
        >
          {t("menu.trade.getStarted")}
        </span>
        <div className="row w-100 order-1">
          <SubMenuItem
            title={t("menu.trade.exchange.title")}
            description={t("menu.trade.exchange.description")}
            imageSrc={data.exchangeIcon.publicURL}
            linkTo={t("menu.trade.exchange.link")}
          />
        </div>
        <div className="row w-100 order-2">
          {siteCountry === "id" ? (
            <div className="row ml-3 mt-3">
              <Link className="col p-0" to={`/fee-schedule/`}>
                <h6>{t("menu.trade.fees.title")}</h6>
                <span>{t("menu.trade.fees.description")}</span>

                <p className="content-link mt-2">
                  {t("menu.trade.fees.seeFees")}
                </p>
              </Link>
              <div className="col-1 p-0 d-flex text-center">
                <div
                  className="align-self-center"
                  style={{
                    borderRight: "1px solid rgba(168,178,188,0.2)",
                    height: "80%",
                    marginBottom: "1rem",
                  }}
                />
              </div>
              <Link className="col p-0" to={`/trade/zipstocks/`}>
                <h6>{t("menu.trade.zipstocks.title")}</h6>
                <span>{t("menu.trade.zipstocks.description")}</span>

                <p className="content-link mt-2">
                  {t("menu.trade.zipstocks.learnMore")}
                </p>
              </Link>
            </div>
          ) : (
            <SubMenuItem
              title={t("menu.trade.fees.title")}
              description={t("menu.trade.fees.description")}
              imageSrc={data.feesIcon.publicURL}
              linkTo={`/fee-schedule/`}
            />
          )}
        </div>
      </div>
      <div className="col mx-1 mx-xl-3 mt-5 pt-1">
        <h5>{t("menu.trade.content.title")}</h5>
        <span>{t("menu.trade.content.description")}</span>
        <div className="mt-4">
          <a
            href="https://zipmex.onelink.me/8NSq/15940e3a"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <AppStoreIcon className="mr-2" />
          </a>

          <a
            href="https://zipmex.onelink.me/8NSq/15940e3a"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <GooglePlayIcon />
          </a>
        </div>
      </div>
      <div className="col-4 mx-1 mx-xl-3 align-self-end">
        <StaticImage
          className="d-block"
          placeholder="none"
          src={"../../../../assets/images/menus/trade.png"}
          alt="trade"
        />
      </div>
    </div>
  );
};

export default TradeMenu;
